import type { ServiceTypeData } from './service-type-data';
import DESIGN_AND_BUILD_CATEGORY_DATA from './design-and-build';
import DESIGN_AND_RENOVATE_CATEGORY_DATA from './design-and-renovate';
import HOME_DATA from './types/home';
import BARN_DATA from './types/barn';
import COTTAGE_DATA from './types/cottage';
import SHOP_DATA from './types/shop';

import BUNKHOUSE_DATA from './types/bunkhouse';
import KITCHEN_DATA from './types/kitchen';
import BASEMENT_DATA from './types/basement';
import BATHROOM_DATA from './types/bathroom';
import ADDITION_DATA from './types/addition';
import GARAGE_DATA from './types/garage';
import SCREENED_IN_PORCH_DATA from './types/screened-in-porch';
import BOAT_HOUSE_DATA from './types/boat-house';
import BUNKHOUSE_RENOVATION_DATA from './types/bunkhouse-renovation';

export type { ServiceTypeData };
export type { ServiceCategoryPageData } from './design-and-build';

export { DESIGN_AND_BUILD_CATEGORY_DATA };
export { DESIGN_AND_RENOVATE_CATEGORY_DATA };

export const SERVICE_TYPE_DATA_MAP: Record<string, ServiceTypeData> = {
  home: HOME_DATA,
  barn: BARN_DATA,
  cottage: COTTAGE_DATA,
  shop: SHOP_DATA,
  bunkhouse: BUNKHOUSE_DATA,
};

export const RENOVATION_TYPE_DATA_MAP: Record<string, ServiceTypeData> = {
  kitchen: KITCHEN_DATA,
  bathroom: BATHROOM_DATA,
  basement: BASEMENT_DATA,
  addition: ADDITION_DATA,
  garage: GARAGE_DATA,
  'screened-in-porch': SCREENED_IN_PORCH_DATA,
  'boat-house': BOAT_HOUSE_DATA,
  bunkhouse: BUNKHOUSE_RENOVATION_DATA,
};
